var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderIconCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3809 13.4626C28.929 7.31882 22.163 11.3175 18.7386 11.2696C15.8321 11.2261 14.9314 8.61981 10.7238 8.6111C6.11161 8.6024 2.87001 11.3697 1.22093 14.5722C-1.53334 19.9154 0.10269 31.7679 8.90504 37.3765C16.9416 42.4978 27.8281 39.5607 33.08 33.4256C38.2926 27.3384 38.8583 18.5099 34.3766 13.4626M25.9223 33.6084C22.9244 35.4924 19.8569 34.4873 18.9562 33.8477C18.7038 33.6693 18.6951 33.3038 19.0606 33.2298C19.7394 33.0906 22.1064 32.4858 24.2907 31.1065C26.1486 29.9317 27.5714 28.4958 28.3242 27.4776C28.5678 27.1469 28.6287 27.0686 28.7941 27.0686C28.9594 27.0686 29.029 27.2253 29.09 27.4559C29.3815 28.5654 28.9812 31.6808 25.918 33.6127",
    fill: "#9CA0A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.334 9.42032C17.7204 9.32024 17.5246 8.25421 17.6856 6.94452C17.8771 5.38681 18.8126 3.67682 21.3493 2.96758C24.7345 2.02339 25.6221 1.79278 26.6968 1.21843C27.5758 0.748503 27.9848 0.409114 28.3329 0.12629C28.6418 -0.126076 29.0029 0.00880958 29.1248 0.313389C29.5294 1.33156 30.1255 5.80017 25.4481 6.94017C22.9201 7.55368 20.9272 8.15414 20.131 8.49353C18.8343 9.04612 18.8778 9.50734 18.3383 9.41597",
    fill: "#9CA0A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIconCard);
export default __webpack_public_path__ + "static/media/placeholder_icon_card.43cd6e588c6fd88ad7481dd785a66e23.svg";
export { ForwardRef as ReactComponent };